((document, Drupal) => {
  "use strict";

  Drupal.behaviors.contentSection = {
    attach: function (context) {
      const highlights = document.querySelectorAll(".content-section--highlights");
      if (highlights) {
        highlights.forEach((section, index) => {
          const navigation = section.querySelector(".content-section__navigation");
          navigation.classList.add('is-shown');
          const slider = section.querySelector(".swiper");
          if (slider.querySelectorAll(".content-section__item").length > 1) {
            const swiper = new Swiper(slider, {
              slideClass: "content-section__item",
              slidesPerView: window.innerWidth >= 768 ? 3 : 1,
              slidesPerGroup: window.innerWidth >= 768 ? 3 : 1,
              spaceBetween: 30,
              loop: true,
              autoplay: {
                delay: 5000,
                disableOnInteraction: false,
              },
              navigation: {
                nextEl: section.querySelector(".swiper-button-next"),
                prevEl: section.querySelector(".swiper-button-prev"),
              },
            });

            const pauseBtn = section.querySelector(".content-section__autoplay-toggle");
            if (pauseBtn) {
              pauseBtn.addEventListener("click", function () {
                const isPaused = pauseBtn.getAttribute("aria-pressed") === "true";
                if (isPaused) {
                  swiper.autoplay.start();
                  pauseBtn.setAttribute("aria-pressed", "false");
                  pauseBtn.setAttribute("aria-label", Drupal.t("Pause slideshow"));
                } else {
                  swiper.autoplay.stop();
                  pauseBtn.setAttribute("aria-pressed", "true");
                  pauseBtn.setAttribute("aria-label", Drupal.t("Play slideshow"));
                }
              });
            }

            return swiper;
          }
        });
      }
    },
  };
})(document, Drupal);
